import styled from "@emotion/styled";
import {
  type Attachment,
  type ExtendedAppointmentAttachment,
  type HomeProjectAttachment,
} from "@repo/api";
import { Accordion, AccordionItem, LightMode } from "@repo/skapa";

import { type FileLoadingEnum } from "../utils";
import { AppointmentFilesList } from "./AppointmentFilesList";
import { HomeProjectFilesList } from "./HomeProjectFilesList";
import { ProjectFilesList } from "./ProjectFilesList";

export interface FilesListBaseProps {
  editable?: boolean;
  loading?: FileLoadingEnum;
  loadingFileId?: number;
  onDownload: (
    name: string,
    attachmentId: number,
    action: "OPEN" | "DOWNLOAD",
    mimeType: string,
    url?: string
  ) => void;
  onDelete?: (attachmentId: number) => void;
  onShare?: (attachmentId: number, shared: boolean) => void;
}

interface FilesListProps extends FilesListBaseProps {
  attachments?: Attachment[];
  appointmentAttachments?: ExtendedAppointmentAttachment[];
  homeProjectAttachments?: HomeProjectAttachment[];
}

export const AttachmentAccordionItem = styled(AccordionItem)`
  div[role="heading"] {
    background-color: ${LightMode.colourNeutral2};
  }
`;

export const FilesList = ({
  attachments,
  appointmentAttachments,
  homeProjectAttachments,
  editable,
  loading,
  loadingFileId,
  onDownload,
  onDelete,
  onShare,
}: FilesListProps) => {
  return (
    <Accordion size="small" collapsible={false}>
      <ProjectFilesList
        files={attachments}
        editable={editable}
        loading={loading}
        loadingFileId={loadingFileId}
        onDownload={onDownload}
        onDelete={onDelete}
        onShare={onShare}
      />
      <AppointmentFilesList
        files={appointmentAttachments}
        editable={editable}
        loading={loading}
        loadingFileId={loadingFileId}
        onDownload={onDownload}
        onShare={onShare}
      />
      <HomeProjectFilesList
        files={homeProjectAttachments}
        editable={editable}
        loading={loading}
        loadingFileId={loadingFileId}
        onDownload={onDownload}
        onShare={onShare}
      />
    </Accordion>
  );
};
